/* Komodin liste sayfası (kategori + arama + mağaza) çalışma zamanı: filtre akordiyonu (R8), filtre seçimi sayfa 1'i yeniden sorgular,
   sıralama açılır kutusu, mobil sıralama/filtre alt sayfaları, hızlı filtre çipleri, sonsuz liste (R11, ?page=N — engellenebilir URL kalıbı). */
(function () {
  'use strict';
  var d = document, w = window;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  function root() { return qs('[data-kt-listing]'); }
  function sectionEl(r) { return r && r.closest('.shopify-section'); }

  function currentParams() { return new URLSearchParams(location.search); }

  function state(r) {
    var openGroups = qsa('[data-kt-filter-group][aria-expanded="true"]', r).map(function (b) { return b.closest('[data-kt-filter-root]') ? qsa('[data-kt-filter-group]', b.closest('[data-kt-filter-root]')).indexOf(b) + ':' + (b.closest('[data-kt-filter-sheet]') ? 's' : 'a') : ''; });
    return { groups: openGroups, filterSheet: !qs('[data-kt-filter-sheet]', r).classList.contains('kt-gizli') };
  }
  function restore(r, st) {
    st.groups.forEach(function (key) {
      var p = key.split(':'); var i = +p[0]; var inSheet = p[1] === 's';
      var rootEl = inSheet ? qs('[data-kt-filter-sheet] [data-kt-filter-root]', r) : qs('aside [data-kt-filter-root]', r);
      var btn = rootEl && qsa('[data-kt-filter-group]', rootEl)[i]; if (btn) toggleGroup(btn, true);
    });
    if (st.filterSheet) openSheet(qs('[data-kt-filter-sheet]', r));
  }

  /* stok tercihi (kullanıcı kararı A): liste varsayılan olarak "Stokta" ile açılır; müşteri kapatırsa tercih kalıcıdır */
  var STOK_KEY = 'kt_stok';
  /* Tur 5: tercih değerleri — yok: varsayılan (açık stil + ✓), 'tumu': müşteri kapattı, 'secili': müşteri kendisi açtı (kaynak basılı siyah stil) */
  function rememberStock(r, params) {
    var chip = r && qs('[data-kt-quick-filter="stokta"]', r); if (!chip) return;
    var nm = chip.getAttribute('data-param'), val = chip.getAttribute('data-value');
    var on = params.getAll(nm).indexOf(val) >= 0, was = currentParams().getAll(nm).indexOf(val) >= 0;
    try {
      if (!on) w.localStorage.setItem(STOK_KEY, 'tumu');
      else if (!was) { w.localStorage.setItem(STOK_KEY, 'secili'); d.documentElement.classList.remove('kt-stok-varsayilan'); }
    } catch (e) {}
  }
  function markReady() { var r = root(); if (r) r.setAttribute('data-kt-listing-ready', '1'); d.documentElement.classList.remove('kt-stok-bekle'); }

  var busy = false;
  function load(params, opts) {
    var r = root(); if (!r || busy) return;
    var sec = sectionEl(r); var id = r.getAttribute('data-section-id');
    params.delete('page'); params.delete('section_id');
    if (!(opts && opts.keepPref)) rememberStock(r, params);
    var url = location.pathname + (params.toString() ? '?' + params.toString() : '');
    var st = state(r);
    busy = true; r.classList.add('kt-yukleniyor');
    /* Tur 5 eki: aramada stok + fiyat filtresi birlikteyken Shopify'ın Section Rendering yanıtı search.filters'tan fiyat
       filtresini düşürüyor (tam sayfa yanıtında var) → "Ücretsiz Kargo" çipi, Fiyat ve Kargo grupları kayboluyordu.
       Aramada tam sayfa alınır ve [data-kt-listing] ayıklanır; kategori Section Rendering ile kalır. Ayrıştırma etkisiz
       belgede (DOMParser): görseller yalnız sayfaya eklenen düğümler için yüklenir. */
    var isSearch = r.getAttribute('data-mode') === 'search';
    var fetchUrl = isSearch ? url : url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
    fetch(fetchUrl, { credentials: 'same-origin' }).then(function (res) { return res.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-kt-listing]');
      if (fresh) fresh = d.importNode(fresh, true);
      if (fresh && sec) { r.replaceWith(fresh); }
      if (!(opts && opts.noPush)) history.replaceState(null, '', url);
      busy = false;
      var nr = root(); restore(nr, st); initFeed(nr);
      if (w.KT && w.KT.markFavs) w.KT.markFavs();
      if (opts && opts.done) opts.done();
    }).catch(function () { busy = false; r.classList.remove('kt-yukleniyor'); if (opts && opts.fail) opts.fail(); else location.href = url; });
  }

  function toggleGroup(btn, force) {
    var wrap = btn.closest('[data-kt-filter-wrap]'); var panel = wrap && qs('[data-kt-filter-panel]', wrap);
    var open = force !== undefined ? force : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  function openSheet(s) { if (!s) return; s.classList.remove('kt-gizli'); if (w.KT) w.KT.lock(); }
  function closeSheets() { qsa('[data-kt-sort-sheet],[data-kt-filter-sheet]').forEach(function (s) { if (!s.classList.contains('kt-gizli')) { s.classList.add('kt-gizli'); if (w.KT) w.KT.unlock(); } }); }

  d.addEventListener('click', function (e) {
    var t = e.target;
    var r = root(); if (!r || !r.contains(t)) return;
    var cl = t.closest('[data-kt-clear],[data-kt-remove]');
    if (cl && cl.href) { try { rememberStock(r, new URL(cl.href, location.href).searchParams); } catch (err) {} }
    var g = t.closest('[data-kt-filter-group]');
    if (g) { e.preventDefault(); toggleGroup(g); return; }
    var cf = t.closest('[data-kt-cat-filter]');
    if (cf) { e.preventDefault(); if (cf.getAttribute('aria-checked') === 'true') clearCat(r); else applyCat(r, cf.getAttribute('data-url'), cf.getAttribute('data-label')); return; }
    if (t.closest('[data-kt-cat-clear]')) { e.preventDefault(); clearCat(r); return; }
    var opt = t.closest('[data-kt-filter-option]');
    if (opt) {
      e.preventDefault();
      var p = currentParams(), name = opt.getAttribute('data-param'), val = opt.getAttribute('data-value');
      var on = opt.getAttribute('aria-checked') === 'true';
      var vals = p.getAll(name).filter(function (x) { return x !== val; });
      p.delete(name); vals.forEach(function (x) { p.append(name, x); });
      if (!on) p.append(name, val);
      opt.setAttribute('aria-checked', on ? 'false' : 'true');
      load(p); return;
    }
    var q = t.closest('[data-kt-quick-filter]');
    if (q) {
      e.preventDefault();
      var p2 = currentParams(), n2 = q.getAttribute('data-param'), v2 = q.getAttribute('data-value');
      var active = q.getAttribute('aria-pressed') === 'true';
      if (active) { var keep = p2.getAll(n2).filter(function (x) { return x !== v2; }); p2.delete(n2); keep.forEach(function (x) { p2.append(n2, x); }); }
      else { if (n2.indexOf('price') >= 0) p2.delete(n2); p2.append(n2, v2); }
      qsa('[data-kt-quick-filter="' + q.getAttribute('data-kt-quick-filter') + '"]', r).forEach(function (b) { b.setAttribute('aria-pressed', active ? 'false' : 'true'); if (b.getAttribute('role') === 'checkbox') b.setAttribute('aria-checked', active ? 'false' : 'true'); });
      load(p2); return;
    }
    if (t.closest('[data-kt-apply]')) {
      e.preventDefault();
      var p3 = currentParams();
      qsa('aside [data-kt-price] input', r).forEach(function (inp) { var nm = inp.getAttribute('data-param'); p3.delete(nm); if (inp.value !== '') p3.set(nm, inp.value); });
      load(p3); return;
    }
    var rm = t.closest('[data-kt-remove],[data-kt-clear]');
    if (rm) { e.preventDefault(); var u = new URL(rm.href, location.origin); load(new URLSearchParams(u.search)); return; }
    var trig = t.closest('[data-kt-sort-trigger]');
    if (trig) {
      e.preventDefault();
      var menu = qs('[data-kt-sort-menu]', trig.parentNode); var open = menu.classList.contains('kt-gizli');
      menu.classList.toggle('kt-gizli', !open); trig.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    var so = t.closest('[data-kt-sort-option]');
    if (so) {
      e.preventDefault();
      var p4 = currentParams(), v4 = so.getAttribute('data-value');
      if (v4 === r.getAttribute('data-default-sort')) p4.delete('sort_by'); else p4.set('sort_by', v4);
      closeSheets(); load(p4); return;
    }
    if (t.closest('[data-kt-open-sort]')) { e.preventDefault(); openSheet(qs('[data-kt-sort-sheet]', r)); return; }
    if (t.closest('[data-kt-open-filter]')) { e.preventDefault(); openSheet(qs('[data-kt-filter-sheet]', r)); return; }
    if (t.closest('[data-kt-sheet-close]')) { e.preventDefault(); closeSheets(); return; }
  });
  d.addEventListener('click', function (e) {
    qsa('[data-kt-sort-menu]').forEach(function (m) {
      if (m.classList.contains('kt-gizli')) return;
      var wrap = m.closest('[data-kt-sort-wrap]'); if (wrap && !wrap.contains(e.target)) { m.classList.add('kt-gizli'); var tg = qs('[data-kt-sort-trigger]', wrap); if (tg) tg.setAttribute('aria-expanded', 'false'); }
    });
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSheets();
    qsa('[data-kt-sort-menu]').forEach(function (m) { m.classList.add('kt-gizli'); });
  });

  /* kategori grubu: alt koleksiyon seçimi ızgarayı yerinde süzer (büyük koleksiyonlarda Shopify filtreleri çalışmadığı için) */
  function applyCat(r, url, label) {
    if (!url) return;
    var id = r.getAttribute('data-section-id');
    r.classList.add('kt-yukleniyor');
    var fp = new URLSearchParams(); currentParams().forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by') fp.append(k, v); });
    var q = fp.toString();
    fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + (q ? q + '&' : '') + 'section_id=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function (res) { return res.text(); }).then(function (html) {
      var tmp = d.createElement('div'); tmp.innerHTML = html;
      var g = qs('[data-kt-grid]', tmp), cnt = qs('[data-kt-count]', tmp);
      var cur = qs('[data-kt-grid]', r);
      if (g && cur) cur.replaceWith(g);
      if (cnt) qsa('[data-kt-count]', r).forEach(function (c) { c.textContent = cnt.textContent; });
      var n = cnt ? cnt.textContent.replace(/[^0-9.+]/g, '') : '';
      qsa('[data-kt-count-plain]', r).forEach(function (c) { c.textContent = '( ' + n + ' )'; });
      qsa('[data-kt-cat-filter]', r).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-url') === url ? 'true' : 'false'); });
      /* kaynakta tek seçim satırı + tek "Temizle": sunucu filtresi (ör. varsayılan Stokta) varsa kategori çipi o satıra eklenir;
         başlıkta yalnız kategori Temizle'si kalır ve seçimi kaldırıp varsayılan görünüme döner (yeniden çizimde sunucu Temizle'si geri gelir) */
      var chips = qs('[data-kt-cat-chips]', r), host = qs('[data-kt-active-chips]', r);
      if (host || chips) {
        var b = d.createElement('button'); b.type = 'button'; b.setAttribute('data-kt-cat-clear', ''); b.setAttribute('data-kt-cat-chip', '');
        b.className = 'inline-flex items-center gap-1.5 cursor-pointer font-sans text-[11.5px] font-semibold text-[#42454c] bg-[#f4f4f6] border border-[#e6e6ea] rounded-full px-2.5 py-1 hover:bg-[#eaeaea] transition-colors';
        b.textContent = label || ''; b.insertAdjacentHTML('beforeend', '<svg class="w-[11px] h-[11px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>');
        if (host) { qsa('[data-kt-cat-chip]', host).forEach(function (x) { x.remove(); }); host.appendChild(b); }
        else { chips.innerHTML = ''; chips.appendChild(b); chips.classList.remove('kt-gizli'); }
      }
      qsa('button[data-kt-cat-clear].kt-gizli', r).forEach(function (x) {
        x.classList.remove('kt-gizli');
        var sv = x.parentNode && qs('a[data-kt-clear]', x.parentNode);
        if (sv) sv.classList.add('kt-gizli');
      });
      r.setAttribute('data-feed-path', new URL(url, location.origin).pathname);
      r.classList.remove('kt-yukleniyor');
      try { history.replaceState(null, '', location.pathname + location.search + '#kategori=' + encodeURIComponent(new URL(url, location.origin).pathname.split('/').pop())); } catch (err) {}
      initFeed(r); if (w.KT && w.KT.markFavs) w.KT.markFavs();
    }).catch(function () { r.classList.remove('kt-yukleniyor'); location.href = url; });
  }
  function clearCat(r) {
    try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
    r.removeAttribute('data-feed-path');
    load(currentParams(), { noPush: true });
  }

  /* sonsuz liste */
  var io = null;
  function initFeed(r) {
    if (!r) return;
    if (io) { io.disconnect(); io = null; }
    var grid = qs('[data-kt-grid]', r), sentinel = qs('[data-kt-feed-sentinel]', r);
    if (!grid || !sentinel) return;
    var page = +grid.getAttribute('data-page') || 1, pages = +grid.getAttribute('data-pages') || 1, loading = false;
    var status = qs('[data-kt-feed-status]', r), lo = status && qs('[data-kt-feed-loading]', status), retry = status && qs('[data-kt-feed-retry]', status);
    if (page >= pages) return;
    function next() {
      if (loading || page >= pages) return; loading = true;
      if (status) { status.hidden = false; lo.hidden = false; retry.hidden = true; }
      var p = r.getAttribute('data-feed-path') ? new URLSearchParams() : currentParams(); p.set('page', String(page + 1)); p.set('section_id', r.getAttribute('data-section-id'));
      fetch((r.getAttribute('data-feed-path') || location.pathname) + '?' + p.toString(), { credentials: 'same-origin' }).then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); }).then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html; var g = qs('[data-kt-grid]', tmp);
        if (g) while (g.firstElementChild) grid.appendChild(g.firstElementChild);
        page++; loading = false; if (status) status.hidden = true;
        if (w.KT && w.KT.markFavs) w.KT.markFavs();
        if (page >= pages && io) io.disconnect();
      }).catch(function () { loading = false; if (status) { status.hidden = false; lo.hidden = true; retry.hidden = false; } });
    }
    if (retry) retry.addEventListener('click', next);
    if ('IntersectionObserver' in w) { io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) next(); }); }, { rootMargin: '500px 0px' }); io.observe(sentinel); }
  }

  /* URL'de filtre yoksa ve müşteri "tüm ürünler" seçmediyse "Stokta" uygulanır (init); ızgara o sırada iskelet (kt-head satır içi betiği) */
  function restoreCatHash() {
    var r = root(); var m = r && location.hash.match(/^#kategori=([^&]+)/);
    if (m) { var h = decodeURIComponent(m[1]); var b = qsa('[data-kt-cat-filter]', r).filter(function (x) { return x.getAttribute('data-url').split('/').pop() === h; })[0]; if (b) applyCat(r, b.getAttribute('data-url'), b.getAttribute('data-label')); }
  }
  function init() {
    var r = root(); initFeed(r);
    if (d.documentElement.classList.contains('kt-stok-bekle')) {
      var chip = r && qs('[data-kt-quick-filter="stokta"]', r);
      if (!chip) { markReady(); restoreCatHash(); return; }
      qsa('[data-kt-quick-filter="stokta"]', r).forEach(function (x) { x.setAttribute('aria-pressed', 'true'); });
      var p = currentParams(); p.append(chip.getAttribute('data-param'), chip.getAttribute('data-value'));
      load(p, { keepPref: true, done: function () { markReady(); restoreCatHash(); }, fail: function () { markReady(); restoreCatHash(); } });
      return;
    }
    markReady(); restoreCatHash();
  }
  if (w.KT && w.KT.register) w.KT.register(init); else if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
